<template>
    <div>
        <!-- ●●●上部メニュー●●● -->
        <Header :type="menu_type" :title="title" />
        <div class="container-fluid px-4 py-4 min-vh-85">
            <!-- ●●●コンテンツ●●● -->
            <div class="mt-0">
            <!-- ●●●メインコンテンツ●●● -->
            <div id="content-menu" class="my-2 mx-0" role="main">
                <!-- ●●●1件目●●● -->
                <section class="" id="menu-1">
                    <!-- ●●●メニュータイトル●●● -->
                    <div class="user-header alt bg-none">
                        <div class="media">
                            <div class="media-body pb-3">
                                <h5 class="text-secondary m-0"><span class="oi oi-cart"></span> QUERYメニュー</h5>
                            </div>
                        </div>
                    </div>
                    <!-- ●●●メニュー●●● -->
                    <div id="collapse-menu0" class="row collapse show">
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['1']" @shortkey="executeShortcut('query-show-record')">
                            <router-link to="/query-show-record"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="1" id="menu1-1">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">1</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">得意先別売上額照会</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>ファイル作成相当の機能含む</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['2']" @shortkey="executeShortcut('query-client-sales-by-month')">
                            <router-link to="/query-client-sales-by-month"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="3" id="menu1-3">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">2</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">得意先別売上額（年月指定）照会</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>得意先の月別売上額と粗利の参照画面です。</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['3']" @shortkey="executeShortcut('query-sales-by-month')">
                            <router-link to="/query-sales-by-month"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="2" id="menu1-2">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">3</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">担当者別売上額（年月指定）照会</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>担当者の月別売上額と粗利の参照画面です。</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <Footer />
    </div>
</template>
<script>
import Header from '@/components/navigation/header.vue';
import Footer from '@/components/navigation/footer.vue';
import {init} from '@/assets/js/common.js'
export default {
  name: 'MENU-SALES-QUERY',
  /** コンポーネント */
  components: {
    Header,
    Footer
  },
  /** データ */
  data() {
    return {
      // ヘッダ
      menu_type: 'user',
      title: 'QUERYメニュー',
    }
  },
  /* マウント */
  mounted() {
    init(); // common.jsにて初期化処理
    this.$store.commit('setLoading', false);
  },
  methods: {
    // ショートカットキー押下時処理
    executeShortcut(path) {
      // パスを受け取って遷移
      console.log('shortcut');
      this.$router.push(`/${path}`);
    },
  },
}
</script>